const IconInstagram = (props) => {
    return (
        <svg className={props.className} width="54" fill="none" stroke="#486f88" height="54" viewBox="0 0 54 54" xmlns="http://www.w3.org/2000/svg">
            <g id="Group_524" data-name="Group 524" transform="translate(-712 -606)">

                <g id="Icon_feather-instagram" data-name="Icon feather-instagram" transform="translate(721 615)">
                    <path id="Path_269" data-name="Path 269" d="M10.5,3h15A7.5,7.5,0,0,1,33,10.5v15A7.5,7.5,0,0,1,25.5,33h-15A7.5,7.5,0,0,1,3,25.5v-15A7.5,7.5,0,0,1,10.5,3Z" fill="none" stroke="#486f88" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                    <path id="Path_270" data-name="Path 270" d="M24,17.055A6,6,0,1,1,18.945,12,6,6,0,0,1,24,17.055Z" fill="none" stroke="#486f88" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                    <path id="Path_271" data-name="Path 271" d="M26.25,9.75h0" fill="none" stroke="#486f88" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                </g>
            </g>
        </svg>
    )
}

export default IconInstagram;